import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'
import { Link } from '@wartek-id/link'

import {
  PROVINCE_NAME_GARUDA,
  URL_GFORM_SUBMIT_DOCS_GARUDA,
} from '../constants'
import { useAPIGetKepalaSekolahEligibility } from 'api/bcks/useAPIBCKSQualification'

import type { HTMLProps } from 'node_modules/@types/react'

const SectionInfoGaruda = ({
  className,
  ...props
}: HTMLProps<HTMLDivElement>) => {
  const { data: responseGetKSEligibility, isLoading: isLoadingKSEligibility } =
    useAPIGetKepalaSekolahEligibility()

  if (
    isLoadingKSEligibility ||
    responseGetKSEligibility?.currentAssignment?.provinsiSekolah?.value.toLowerCase() !==
      PROVINCE_NAME_GARUDA.toLowerCase()
  ) {
    return null
  }

  return (
    <div
      className={clsx('bg-surface-informational-subdued p-4', className)}
      {...props}
    >
      <Text>
        Dokumen lainnya yang wajib diunggah BCKS yang mengikuti seleksi
        penugasan <strong>Kepala Sekolah Unggul Garuda</strong>
      </Text>

      <ul className="list-inside list-disc mt-1">
        <li>Surat Persetujuan mengikuti proses dari Pejabat</li>
        <li>Surat Lamaran</li>
        <li>Surat Pernyataan bersedia tinggal di asrama</li>
        <li>CV</li>
        <li>Salinan Ijazah dan Transkrip Nilai</li>
        <li>
          Sertifikat Kemampuan Bahasa Inggris sebagai persyaratan administrasi
        </li>
      </ul>

      <Link href={URL_GFORM_SUBMIT_DOCS_GARUDA} className="inline-block mt-4">
        <strong>Unggah di sini</strong>
      </Link>
    </div>
  )
}

export default SectionInfoGaruda
